/* PrimaryMenu.js */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { menuItems } from "constants/Constants";
import { useFeaturePermissions } from "constants/FeaturePermissions";
import { Menu, MenuItem, Button } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Dropdown from "components/elements/dropdown/Dropdown";

const PrimaryMenu = ({ activeMenu, setActiveMenu }) => {
  const [activePath, setActivePath] = useState("");
  const { permissionManager } = useFeaturePermissions();

  useEffect(() => {
    setActivePath(window.location.pathname);
  }, [window.location.pathname]);

  // Get authorized menu items for the current user
  const authorizedMenuItems =
    permissionManager.getAuthorizedMenuItems(menuItems);

  // Common styles for better maintainability
  const getLinkStyles = (isActive) => ({
    color: isActive ? "rgba(35, 71, 159, 1)" : "rgba(104, 104, 104, 1)",
    textDecoration: isActive ? "underline" : "none",
    textUnderlineOffset: "10px",
  });

  const handleMenuClick = (index) => {
    setActiveMenu(index);
  };

  return (
    <>
      {authorizedMenuItems.map((menu, index) => {
        const isActive = activePath === menu.path;

        if (menu.hasDropdown) {
          return (
            <Dropdown
              key={`${menu.title}-${index}`}
              title={menu.title}
              dropdownMenu={menu.dropdownOptions}
            />
          );
        }

        return (
          <Link
            key={`${menu.path}-${index}`}
            to={menu.path}
            className={`mx-2 ${isActive ? "active-link" : ""}`}
            onClick={() => handleMenuClick(index)}
            style={getLinkStyles(isActive)}
          >
            {menu.title}
          </Link>
        );
      })}
    </>
  );
};

export default PrimaryMenu;
